<script>
    import {onMount} from "svelte";
    import {GET, POST} from "../../components/communication.js";
    import {navigate} from "svelte-routing";
    import {userData} from "../../components/stores.js";

    // Generoidut treenit on jaettu kahteen osaan
    let workouts = undefined;
    let crossfitWorkouts = undefined;
    let workoutType = "crossfit"; // tai 'kuntosali' - Nyt preferoidaan crossfitiä
    let loading = false;

    onMount(async function () {
        if ($userData && $userData.id) {
            console.log("onMount ");
            getGeneratedWods(workoutType); // Eli defaulttina crossfit
        } else {
            // Koodatessa ja selaimen automaattisella päivityksellä käyttäjän tietoja ei haieta
            // Automaattisesti, joten tänne tullaan aivan liian usein. Siksi automatic redirect
            console.log("getData :: userData puuttuu");
            navigate('/c/home', {replace: false});
        }
    });

    async function getGeneratedWods(workoutType) {
        loading = true;
        // Haetaan jo aiemmin generoituja treenejä
        console.log("getGeneratedWods :: workoutType: ", workoutType);
        const response = POST("/c/getGeneratedWorkouts", JSON.stringify({workoutType: workoutType}));
        let data;
        try {
            data = await response;
        } catch (e) {
            console.log("getGeneratedWods :: error: ", e);
        }

        if (data) {
            workouts = data.workouts;
            crossfitWorkouts = data.crossfitWorkouts;
        }
        loading = false;
    }

    /*Pikasetti tabien näyttämiseen*/
    let tab = 'w1';

    function showWorkoutTab(index) {
        tab = 'w' + index;
    }

    function showCrossfitTab(index) {
        tab = 'c' + index;
    }

    // Chrome odottaa käyttäjäinputtia, ennenkuin printtaa. Niinpä tehdään pieni odotushomma chromekäyttäjille
    var is_chrome = function () {
        return Boolean(window.chrome);
    }

    // Mahdollistetaan treenin tulostus esin pdf:ksi
    function printDivContent(divId, title) {
        const content = document.getElementById(divId).innerHTML;
        const printWindow = window.open('', '_blank');

        printWindow.document.write('<!DOCTYPE html>\n' +
            '<html lang="en">' +
            '<head>' +
            '<meta charset=\'utf-8\'>' +
            '<meta name="viewport" content="width=device-width, initial-scale=1" >' +
            '<title>' + title + '</title>' +
            '<link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-T3c6CoIi6uLrA9TneNEoa7RxnatzjcDSCmG1MXxSR1GAsXEV/Dwwykc2MPK8M2HN" crossorigin="anonymous">' +
            '</head>' +
            '<body>');

        // Lisätään skaalauksen mukainen zoomi
        printWindow.document.write('<div class="row" style="padding-top: 10px; padding-left: 20px;">');
        printWindow.document.write(content);
        printWindow.document.write('</div>');
        printWindow.document.write('</body></html>');
        printWindow.document.close();
        printWindow.print();
        if (is_chrome()) {
            setTimeout(function () {
                printWindow.close();
            }, 60000);
        } else {
            printWindow.close();
        }
    }

</script>
<div class="page">
    <div class="container">
        <div class="row">
            <h3>Aiemmin generoidut treenit</h3>
        </div>
        <div class="row">
            <div class="col-md-6">
                <form on:submit|preventDefault={() => getGeneratedWods(workoutType)}>
                    <div class="form-group">
                        <label for="workoutType">Treenityyppi:</label>
                        <select class="form-control" bind:value={workoutType} id="workoutType">
                            <option value="crossfit">Toiminnallinen harjoitus</option>
                            <option value="kuntosali">Kuntosaliharjoitus</option>
                        </select>
                    </div>
                    <button type="submit" class="btn btn-primary">Hae</button>
                </form>

            </div>
        </div>
        <div class="row">
            <div class="col-xs-12 col-md-12">
                {#if workouts && workouts.length >= 1}
                    <div class="row"><h2>Kuntosalitreenit</h2></div>
                    <ul class="nav nav-tabs">
                        {#each workouts as workout, i}
                            <li class="nav-item">
                                <a class="nav-link {tab === 'w'+i.toString() ? 'active' : ''}" aria-current="page"
                                   href="#"
                                   on:click|preventDefault={() => showWorkoutTab(i)}>{workout.name}</a>
                            </li>
                        {/each}
                    </ul>

                    {#each workouts as workout, i}
                        {#if tab === 'w' + i.toString()}
                            <div id="wprint">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="page-title">
                                            <div style="display: flex;">
                                                <h3>{workout.name}</h3>
                                                <button style="position: absolute; right: 0;" on:click={() => printDivContent('wprint', workout.name)}>
                                                    Tulosta
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="page-title ">
                                            <h4>Lämmittely</h4>
                                        </div>
                                    </div>
                                </div>
                                <!-- Näppärä näkymä lämmittelyn näyttämiseen -->
                                {#if workout.warmups}
                                    {#each workout.warmups as w}
                                        <div class="row">
                                            <div class="col-xs-12 col-md-6">
                                                <div>
                                                    <b>{w.name}</b> {w.sets} x {w.reps}</div>
                                                <div>
                                                    <p style="padding-left: 20px;">{w.description}</p>
                                                </div>

                                            </div>
                                        </div>
                                    {/each}
                                {/if}
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="page-title ">
                                            <h4>Treeni</h4>
                                        </div>
                                    </div>
                                </div>
                                <!-- Näppärä näkymä treenien näyttämiseen -->
                                {#if workout.exercises}
                                    {#each workout.exercises as e}
                                        <div class="row">
                                            <div class="col-xs-12 col-md-6">
                                                <div>
                                                    <b>{e.name}</b> {e.sets} x {e.reps}
                                                    {#if e.weight != 'undefined' && e.weight != "0"} ({e.weight}kg)
                                                    {/if}
                                                </div>
                                                <div>
                                                    <p style="padding-left: 20px;">{e.description}</p>
                                                </div>
                                            </div>
                                        </div>
                                    {/each}
                                {/if}
                            </div>
                        {/if}
                    {:else}
                        <div class="container">
                            <p>Generointi menossa...</p>
                        </div>
                    {/each}
                {:else}
                    {#if loading}
                        <div class="container">
                            <p>Haetaan treenejä...</p>
                        </div>
                    {/if}
                {/if}
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12 col-md-12">
                {#if crossfitWorkouts && crossfitWorkouts.length >= 1}
                    <div class="row"><h2>Toiminnalliset treenit</h2></div>
                    <ul class="nav nav-tabs">
                        {#each crossfitWorkouts as workout, i}
                            <li class="nav-item">
                                <a class="nav-link {tab === 'c'+i.toString() ? 'active' : ''}" aria-current="page"
                                   href="#"
                                   on:click|preventDefault={() => showCrossfitTab(i)}>{workout.name}</a>
                            </li>
                        {/each}
                    </ul>
                    {#each crossfitWorkouts as workout, i}
                        {#if tab === 'c' + i.toString()}
                            <div id="cprint">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="page-title">
                                            <div style="display: flex;">
                                                <h3>{workout.name}</h3>
                                                <button style="position: absolute; right: 0;" on:click={() => printDivContent('cprint', workout.name)}>
                                                    Tulosta
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="page-title ">
                                            <h4>Lämmittely</h4>
                                        </div>
                                    </div>
                                </div>
                                <!-- Näppärä näkymä lämmittelyn näyttämiseen -->
                                {#if workout.crossfitWarmups}
                                    {#each workout.crossfitWarmups as w}
                                        <div class="row">
                                            <div class="col-xs-12">
                                                <div>
                                                    <b>{w.name}</b></div>
                                                <div>
                                                    <p style="padding-left: 20px;">{w.description}</p>
                                                </div>

                                            </div>
                                        </div>
                                    {/each}
                                {/if}
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="page-title ">
                                            <h4>Treeni</h4>
                                        </div>
                                    </div>
                                </div>
                                <!-- Näppärä näkymä treenien näyttämiseen -->
                                {#if workout.crossfitExercises}
                                    {#each workout.crossfitExercises as e}
                                        <div class="row">
                                            <div class="col-xs-12">
                                                <div>
                                                    <b>{e.name}</b></div>
                                                <div>
                                                    <p style="padding-left: 20px;">{e.description}</p>
                                                </div>
                                            </div>
                                        </div>
                                    {/each}
                                {/if}
                            </div>
                        {/if}
                    {/each}
                {/if}
            </div>
        </div>
    </div>
</div>
